import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Nebraska",
  shortName: "Nebraska Blue",
  slug: "nebraska-blue-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Nebraska TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Nebraska policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Nebraska Blue TMS coverage, BCBS Nebraska SPRAVATO authorization, Nebraska Blue mental health benefits Coral Springs FL, BCBS Nebraska depression treatment Florida",
};

export const NebraskaBlueInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default NebraskaBlueInsurance;
